import { createApp } from 'vue';

// 全局 toast，loading
import './plugins/index.js';

// 全局样式
import '@/styles/index.less';

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(router);
app.mount('#app');
